import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartDataset, ChartType } from 'chart.js';
import { DatePipe, formatDate } from '@angular/common';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzMarks } from 'ng-zorro-antd/slider';
import { HistoricoPesquisasMensalService } from 'src/app/services/historicoPesquisasMensal.service';

@Component({
  selector: 'app-chart-historico-pesquisas-mensal',
  templateUrl: './chart-historico-pesquisas-mensal.component.html',
  styleUrls: ['./chart-historico-pesquisas-mensal.component.css'],
  standalone: false,
})
export class ChartHistoricoPesquisasMensalComponent implements OnInit, OnChanges {

  @Input() qtdRegistros: number = 11;
  loading = false;

  marks: NzMarks = {
    12: '12',
    24: '24',
    36: '36',
    48: '48',
    60: '60',
    72: '72',
    84: '84',
    96: '96',
  };

  @ViewChild(BaseChartDirective) chart?: BaseChartDirective<'line'>;

  public lineChartType: ChartType = 'line';

  public lineChartData: ChartDataset<'line'>[] = [
    {
      label: 'Histórico',
      data: [],
      backgroundColor: 'rgba(52, 152, 219, 0.49)',
      borderColor: '#3498db',
      pointBorderColor: '#fff',
      fill: true,
    }
  ];

  public lineChartLabels: string[] = [];

  public lineChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      y: {
        beginAtZero: true,
        position: 'right',
        title: {
          display: true,
          text: 'Quantidade'
        }
      },
      x: {
        title: {
          display: true,
          text: 'Período'
        }
      }
    },
    plugins: {
      legend: {
        display: true
      }
    }
  };

  constructor(
    private historicoPesquisasMensalService: HistoricoPesquisasMensalService,
    private message: NzMessageService,
    public datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.loadChart();
  }

  ngOnChanges(): void {
    this.loadChart();
  }

  loadChart() {
    this.loading = true;
    this.initializeChart();

    this.historicoPesquisasMensalService.getHistorico(this.qtdRegistros)
      .subscribe({
        next: (data: any) => {
          const historicos = data.data.historicos.reverse();

          this.lineChartLabels = historicos.map((h: any) =>
            formatDate(h.data_final, 'MM/yyyy', 'en-US')
          );
          this.lineChartData[0].data = historicos.map((h: any) => h.quantidade);

          this.chart?.update();
          this.loading = false;
        },
        error: () => {
          this.message.error('Houve uma falha ao enviar a requisição, tente novamente!');
          this.loading = false;
        }
      });
  }

  initializeChart() {
    this.lineChartLabels = [];
    this.lineChartData[0].data = [];
  }
}
